import {BufferWriter, Writer} from "protobufjs";

import {Message} from "../../../domain/model/message";
import {IMessageRepository} from "../../../domain/repository/message_repository";
import {MessageRoomPartialID} from "../../../domain/model/entity";

import {common, entity, api} from "../rpc/api";
import {getToken} from "./bind_token";
import {IApiClient} from "../client";

import MessageList = entity.MessageList;
import GetAllMessageByRoomRequest = api.GetAllMessageByRoomRequest;

import Pager = common.Pager;

import {
    MessageConvertResponse,
    MessageConvertResponseList
} from "./message_api_convert";
import MessageRoomPartialIDList = api.MessageRoomPartialIDList;

class MessageAPI implements IMessageRepository {
    constructor(readonly apiClient: IApiClient){
    }

    public getAllByRoom(page: number, offset: number, projectID: string, opponentID: string): Promise<Message[]>{
        return new Promise<Message[]>((resolve, reject) => {
            getToken()
                .then((token: string): Promise<Uint8Array> => {
                    const pager: Pager = new Pager();
                    pager.page = page;
                    pager.offset = offset;
                    const req: GetAllMessageByRoomRequest = new GetAllMessageByRoomRequest();
                    req.pager = pager;
                    req.projectID = projectID;
                    req.opponentID = opponentID;
                    const writer: BufferWriter | Writer = Writer.create();
                    return this.apiClient.postWithToken("/api.MessageService/GetAllByRoom", token, GetAllMessageByRoomRequest.encode(req, writer).finish());
                })
                .then((binary: Uint8Array): void => {
                    const res: MessageList = MessageList.decode(binary);
                    // BE=>FE 型変換
                    const resConverted: MessageConvertResponseList = MessageConvertResponseList.from(res);
                    const items: Message[] = resConverted.items.map((item: MessageConvertResponse): Message => {
                        return Message.from(item);
                    });
                    resolve(items);
                })
                .catch((error: Error): void => {
                    reject(error);
                });
        })
    }

    public getAllNewestByRooms(ids: MessageRoomPartialID[]): Promise<Message[]>{
        return new Promise<Message[]>((resolve, reject) => {
            getToken()
                .then((token: string): Promise<Uint8Array> => {
                    const req: MessageRoomPartialIDList = new MessageRoomPartialIDList();
                    req.ids = ids;
                    const writer: BufferWriter | Writer = Writer.create();
                    return this.apiClient.postWithToken("/api.MessageService/GetAllNewestByRooms", token, MessageRoomPartialIDList.encode(req, writer).finish());
                })
                .then((binary: Uint8Array): void => {
                    const res: MessageList = MessageList.decode(binary);
                    // BE=>FE 型変換
                    const resConverted: MessageConvertResponseList = MessageConvertResponseList.from(res);
                    const items: Message[] = resConverted.items.map((item: MessageConvertResponse): Message => {
                        return Message.from(item);
                    });
                    resolve(items);
                })
                .catch((error: Error): void => {
                    reject(error);
                });
        })
    }

}

const createMessageAPI = (apiClient: IApiClient): IMessageRepository => {
    return new MessageAPI(apiClient);
};

export {createMessageAPI};



// WEBPACK FOOTER //
// ./src/infra/api/service/message_api.ts